import React,{useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from 'react-reveal/Slide';
import Gallery from '../sections/Gallery'

import Section from './Section'

import Grid from './Grid'
import Carousel from './Carousel'

const listVariantMaps = {
  Grid: Grid,
  Slideshow: Carousel,
  SlideshowLeft: Carousel,
}

const styles = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
//    padding: theme.spacing(0, 3),
  },
  dialogGallery:{
    height: '100vh',
    [theme.breakpoints.down('xs')]:{
        // height: '40vh'
    }
  }
});

const ListSection = (props) => {
  const { theme, classes, openLink, variant, color, item_size, item_variant, item_count, items, item_spacing, removeNotFullRow=false } = props
  const { item_component_type, createContentBlock } = props

  const [openGallery, setOpenGallery] = React.useState(false);
  const [positions, setPositions] = React.useState(0);
  
  const handleClickOpenGallery = (position) => {
    setPositions(position);
    setOpenGallery(true);
  };

  const handleCloseGallery = () => {
    setOpenGallery(false);
  };

  let textColor
  if(color === 'dark'){
    textColor =  theme.sectionPalette.dark.contrastText
  }else if(color === 'accent'){
    textColor =  theme.sectionPalette.accent.contrastText
  }else if(color === 'light'){
    textColor =  theme.sectionPalette.light.contrastText
  }else if(color === 'white'){
    textColor =  theme.sectionPalette.white.contrastText
  }else{
    textColor =  theme.sectionPalette.black.contrastText
  }

  // let imagesWidth = []
  // const [images,setImages] = useState([])

  useEffect(() => {
    items.map((item,index) => {
      if (item.images && item.images.length > 0) {
        let image = new Image();
        image.src = item.images[0].image_url || ''
        // image.width = 
        image.onload = function() {
            let dimension = {
                width: image.width,
                height: image.height
            };
        };
      }
    })
  }, [])
  
  const itemAttributes = {
    variant: props.item_variant,
    button_style: props.item_button_style,
    item_size: props.item_size,
    text_alignment: props.item_text_alignment,
    animation: props.item_animation,
    image_position: props.item_image_position,
    image_alternate_position: props.item_image_alternate_position,
    image_width: props.item_image_width,
    color: textColor,
    colorType: props.color || 'white',
    index: props.itemIndex,
    item_spacing: props.item_spacing,
    openGallery: openGallery,
    setOpenGallery: handleClickOpenGallery,
    // selected={index === selected_index ? true : false}
    // selected_index: ,
    // selected:
  }

  const createItemBlock = (itemData, index) => {
    itemAttributes.itemIndex = index
    return createContentBlock(item_component_type, itemData, 0, itemAttributes)
  }

  let comp
  if (variant in listVariantMaps)
    comp = listVariantMaps[variant]
  else
    comp = listVariantMaps['Grid']

  let container = React.createElement(comp, {
    item_size: item_size,
    item_count: item_count,
    items: items,
    image_position: props.item_image_position,
    image_alternate_position: props.item_image_alternate_position,
    item_spacing: item_spacing,
    openLink: openLink,
    createItemBlock: createItemBlock
    }) 

  return (
    <Section { ...props }>
      { container }
      <Dialog
        fullWidth={true}
        maxWidth={'xl'}
        open={openGallery}
        onClose={handleCloseGallery}
        aria-labelledby="max-width-dialog-title"
        style={{overflow:'hidden'}}
    >
        <DialogContent className={classes.dialogGallery}>
          <Gallery items={items} activeIndex={positions} closeGallery={handleCloseGallery}/>
        </DialogContent>
      </Dialog>
    </Section>
  )
}

ListSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ListSection);